/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button } from "../../../components/Component";
import Swal from "sweetalert2";
const AdminUserDataUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        activeStatus:"O",
        employmentId: 0,
        employmentRefId: 0
    });
    const [isShown, setIsShown] = useState(false);
   
    const getdata = async () => {
      
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            MonthId: Number(props.month),
            EmploymentRefId: props.parent,
            YearId: Number(props.year),
        }
        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK+'api/Main/Dashdata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data !== "No data") {
                       // console.log(data)
                        setFormData({
                            ...formData,
                            activeStatus: data.activeStatus,
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                      
                    } else {
                        setFormData({
                            ...formData,
                            activeStatus: "O",
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                    }
                   
                    setload(false)
                })


    };

    

    const Recheck = async (emp) => {
     

        const sendData = {
            EmploymentId: Number(emp),
           
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Reopen', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === 'Done') {
                        Swal.fire({
                            icon: "success",
                            title: "Done",
                            text: "Send to Recheck Successfully",
                            focusConfirm: false,
                        });
                    }

                  
                })


    };
    //console.log(props)
    const check = async () => {
        if (props.year > 0 && props.month > 0) {
            const sendData = {
                EmploymentRefId: Number(props.parent),
                UserId: Number(localStorage.getItem("userId")),
                YearId: Number(props.year),
                MonthId: Number(props.month)
            }
            //console.log(sendData)
            await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Checkdraft2', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())

                .then(
                    data => {
                        //console.log(data)
                        if (data === "NO") {
                            window.location.pathname = props.path
                        }
                        else if (data === "Previous Month Data Not Submitted") {
                            Swal.fire({
                                icon: "error",
                                title: "Data Not Submitted",
                                text: "Previous Month Data Not Submitted",
                                focusConfirm: false,
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: data.month + " " + data.yearId,
                                text: data.month + " " + data.yearId + " Data of " + data.table.name + " is Already in Draft",
                                focusConfirm: false,
                            });
                        }

                    })
        } else {
            Swal.fire({
                icon: "warning",
                title: "Month or Year Not Selected",
                text: "Please Select Month and Year",
                focusConfirm: false,
            }).then(() => {
                window.location.reload(true)
            })
        }

    };
    const viewpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.pathname = props.path2             

    };
    const Editpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.pathname = props.path + "-Edit"             

    };

    const Editcheck = async () => {

        Swal.fire({
            icon: "error",
            title: "Form is Not Submitted",
            focusConfirm: false,
        });

    };



    useEffect(() => {
        if (Number(props.year) > 0 && Number(props.month) > 0) {
            getdata()
        }
 

    }, [props.year, props.month])




    return (

        load ? null : <>
            <tbody>
            {localStorage.getItem("urole") === "16" ?
                <tr className="tb-odr-item" style={{ textAlign: 'center' }}>
                    <td>
                        <a
                            href="#id"
                            onClick={(ev) => {
                                ev.preventDefault();
                            }}
                        >
                            <b style={{ fontSize: 18 }}>{props.sno}</b>
                        </a>
                    </td>
                    <td  >
                        <a
                            href="#id"
                            onClick={(ev) => {
                                ev.preventDefault();
                            }}
                        >
                            <b style={{ fontSize: 18 }}>{props.name}</b>
                        </a>
                    </td>
                    <td>
                        {formData.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  Draft</b></> : formData.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> Submitted</b></> : <> <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}> Open</b></>}
                    </td>
                    <td>
                        {formData.activeStatus === "A" ? <Button onClick={(ev) => {
                            ev.preventDefault();
                            Editpage()
                        }} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                            <b style={{ fontSize: 18 }}> Edit <em className="icon ni ni-pen2"></em> </b>
                        </Button> : formData.activeStatus === "S" ? <Button
                            color="success" onClick={(ev) => {
                                ev.preventDefault();
                                viewpage()
                            }} >
                                <b style={{ fontSize: 18 }}>View <em className="icon ni ni-eye-fill"></em></b>
                        </Button> : <Button onClick={(ev) => {
                            ev.preventDefault();
                            check()
                        }} style={{ backgroundColor: "#e85347", color: "white" }} >
                                    <b style={{ fontSize: 18 }}> Add <em className="icon ni ni-property-add"></em>  </b>
                        </Button>}

                    </td>
                    {formData.activeStatus === "S" ?
                        <td>
                            <Button color="success" onClick={() => Recheck(formData.employmentId)}><b style={{ fontSize: 18 }}>Request Edit   <em  class="icon ni ni-check-circle-cut"></em> </b> </Button>
                        </td> :
                        <td>
                            <Button color="dark" onClick={() => Editcheck()}><b style={{ fontSize: 18 }}>Request Edit <em className="icon ni ni-check-circle-cut"></em></b></Button>
                            </td>}

                    </tr>  :
                <tr className="tb-odr-item" style={{ textAlign: 'center' }}>

                    <td>
                        <a
                            href="#id"
                            onClick={(ev) => {
                                ev.preventDefault();
                            }}
                        >
                            <b style={{ fontSize: 18 }}>{props.sno}</b>
                        </a>
                    </td>
                    <td>
                        <a
                            href="#id"
                            onClick={(ev) => {
                                ev.preventDefault();
                            }}
                        >
                            <b style={{ fontSize: 18 }}>{props.name}</b>
                        </a>
                    </td>
                    <td>
                        {formData.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  Draft</b></> : formData.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> Submitted</b></> : <> <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}> Open</b></>}
                    </td>
                    <td>
                        {formData.activeStatus === "A" ? <Button color="success" disabled onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
                            <b style={{ fontSize: 18 }}>{!isShown ? "View" : null}{isShown && (
                                <div>
                                    You cannot View this page.
                                </div>
                            )} <em className="icon ni ni-eye-fill"> </em> </b>
                        </Button> : formData.activeStatus === "S" ? <Button
                            color="success" onClick={(ev) => {
                                ev.preventDefault();
                                viewpage()
                            }} >
                                <b style={{ fontSize: 18 }}>View <em className="icon ni ni-eye-fill"> </em> </b>
                            </Button> : <Button color="success" disabled onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
                                    <b style={{ fontSize: 18 }}>{!isShown ? "View" : null}{isShown && (
                                        <div>
                                            You cannot View this page.
                                        </div>
                                    )} <em className="icon ni ni-eye-fill"> </em> </b>
                        </Button>}

                    </td>
                    
                    </tr>}
            </tbody>
           
           
           
        </>
    );
};

export default AdminUserDataUpdate;
